module.exports = __webpack_public_path__ + "img/chat.a2f52ab6.svg";